import { Box, Text, StyledHtml } from '@postenbring/hedwig-react'

export const InfoBox = ({ title, text }) => (
    <Box variant="lighter" className="hds-mb-20-24">
        <Text variant="h2" as="h2" className="hds-mb-16-20">
            {title}
        </Text>
        <StyledHtml dangerouslySetInnerHTML={{ __html: text }} />
    </Box>
)

